<template>
    <template v-if="userDataLoading">
        <LoadingComponent />
    </template>
    <template v-else>
        <div class="background-div">
        <div class="container">
            <div class="row info-wrapper">
                <div class="col-12 col-lg-6 d-flex flex-column   short-info ps-4 mt-4">
                    <h3 class="text-neutral-25 good-morning text-neutral-100">Welcome,</h3>
                    <h3 class="text-neutral-25  attendee-name">{{ user?.display_name }}</h3>
                </div>
                <div
                    class="col-12 col-lg-6 d-flex justify-content-center align-items-center flex-column mt-4 pb-5 pe-0">
                    <h6 class="text-24 text-neutral-25 text-center">Join in Event</h6>
                    <p class="text-neutral-200 text-center">Join in an event through entering the event code shared by
                        Host or your friends</p>
                    <input type="text" placeholder="Event Code" v-model="eventCode"
                        class="event-encroll-input text-neutral-25 mt-3" />
                    <button :disabled="!eventCode.length" @click="joinEvent"
                        class="btn btn-primary pt-2 pb-2 ps-3 pe-3 mt-3">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <g clip-path="url(#clip0_582_7960)">
                                    <path
                                        d="M13.0006 15.9999C12.8673 16 12.7371 15.9602 12.6267 15.8856C12.5163 15.8109 12.4308 15.705 12.3812 15.5813L11.8186 14.1726L10.4079 13.5786C10.2869 13.5252 10.1844 13.4372 10.1132 13.3256C10.042 13.2141 10.0054 13.0841 10.0079 12.9518C10.0104 12.8196 10.0519 12.691 10.1272 12.5823C10.2025 12.4735 10.3083 12.3894 10.4312 12.3406L11.8232 11.8133L12.3812 10.4186C12.4325 10.2967 12.5187 10.1927 12.6289 10.1195C12.739 10.0464 12.8683 10.0074 13.0006 10.0074C13.1328 10.0074 13.2621 10.0464 13.3723 10.1195C13.4824 10.1927 13.5686 10.2967 13.6199 10.4186L14.1806 11.8186L15.5806 12.3793C15.7027 12.4303 15.807 12.5164 15.8803 12.6266C15.9537 12.7368 15.9928 12.8662 15.9928 12.9986C15.9928 13.131 15.9537 13.2604 15.8803 13.3706C15.807 13.4808 15.7027 13.5668 15.5806 13.6179L14.1806 14.1786L13.6199 15.5786C13.5707 15.7028 13.4854 15.8093 13.375 15.8845C13.2646 15.9596 13.1341 15.9998 13.0006 15.9999ZM6.66723 13.9999C6.37921 14.0034 6.09782 13.9135 5.86516 13.7437C5.6325 13.5739 5.46108 13.3333 5.37656 13.0579L4.30056 9.69326L0.925228 8.56393C0.652804 8.47287 0.416374 8.29758 0.250087 8.06337C0.0838 7.82916 -0.00373593 7.54815 0.000122275 7.26094C0.00398048 6.97372 0.0990331 6.69517 0.271551 6.46551C0.444069 6.23585 0.685123 6.06697 0.959895 5.98326L4.30856 4.9606L5.43656 1.59126C5.52043 1.31451 5.69391 1.07349 5.92973 0.906102C6.16554 0.738716 6.4503 0.654464 6.73923 0.666597C7.02729 0.666987 7.30749 0.76066 7.53787 0.933596C7.76825 1.10653 7.93643 1.34943 8.01723 1.62593L9.03856 4.96926L12.3919 6.0426C12.6624 6.13332 12.8975 6.30672 13.0641 6.53831C13.2307 6.7699 13.3203 7.04798 13.3203 7.33326C13.3203 7.61855 13.2307 7.89662 13.0641 8.12821C12.8975 8.35981 12.6624 8.53321 12.3919 8.62393L9.03256 9.6986L7.95789 13.0579C7.87338 13.3333 7.70196 13.5739 7.4693 13.7437C7.23664 13.9135 6.95525 14.0034 6.66723 13.9999ZM13.6672 4.6666C13.5186 4.66659 13.3743 4.61693 13.2571 4.52549C13.1399 4.43406 13.0567 4.30609 13.0206 4.16193L12.7826 3.2086L11.8272 2.95193C11.6836 2.91335 11.5571 2.82788 11.4676 2.70911C11.3782 2.59033 11.331 2.44507 11.3336 2.29641C11.3363 2.14776 11.3885 2.00424 11.482 1.88867C11.5756 1.7731 11.705 1.69212 11.8499 1.6586L12.7832 1.44193L13.0206 0.504597C13.0567 0.360445 13.1399 0.232498 13.2571 0.141076C13.3743 0.0496542 13.5186 0 13.6672 0C13.8158 0 13.9602 0.0496542 14.0773 0.141076C14.1945 0.232498 14.2778 0.360445 14.3139 0.504597L14.5499 1.44993L15.4952 1.6866C15.6394 1.72272 15.7673 1.80598 15.8587 1.92314C15.9502 2.0403 15.9998 2.18465 15.9998 2.33326C15.9998 2.48187 15.9502 2.62622 15.8587 2.74338C15.7673 2.86055 15.6394 2.9438 15.4952 2.97993L14.5499 3.2166L14.3139 4.16193C14.2778 4.30609 14.1945 4.43406 14.0774 4.52549C13.9602 4.61693 13.8158 4.66659 13.6672 4.6666Z"
                                        fill="#FCFCFC" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_582_7960">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg></span> <span class="ms-1">Join Now</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="event-card-section mt-5">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-neutral-25 text-20">Joined Events</h3>
            <div class="d-flex align-items-center gap-2">
                <button
                    class=" border-0 event-slide-icon text-neutral-25 bg-neutral-800 pt-2 ps-3 pb-2 pe-3 rounded-circle d-flex align-items-center justify-content-center"><i
                        class="fa-solid fa-angle-left"></i></button>
                <button
                    class=" border-0 event-slide-icon text-neutral-25 bg-neutral-800 pt-2 ps-3 pb-2 pe-3 rounded-circle d-flex align-items-center justify-content-center"><i
                        class="fa-solid fa-angle-right "></i></button>
            </div>
        </div>

        <template v-if="chunkedItems.length">
            <div class="mt-3">
                <carousel :settings="carouselSettings">
                    <slide v-for="(chunk, index) in chunkedItems" :key="index">
                        <div class="container p-0 ">
                            <div class="row">
                                <router-link :to="{ name: 'attendee.event.details', params: { eventId: item.id } }"
                                    v-for="item in chunk" :key="item.id"
                                    class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 col-xxl-3 pb-3">
                                    <EventCard :event="item" />
                                </router-link>
                            </div>
                        </div>
                    </slide>
                    <template #addons>
                        <navigation @prev="prevSlide" @next="nextSlide" />
                    </template>
                </carousel>
            </div>
        </template>
        <template v-if="!chunkedItems.length">
            <NoData />
        </template>
    </div>
    </template>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { Slide, Navigation, Carousel } from 'vue3-carousel';
import { useStore } from 'vuex';
import 'vue3-carousel/dist/carousel.css'
import { useToast } from 'vue-toastification';
import EventCard from '@/components/Shared/EventCard.vue';
import NoData from '@/components/Shared/NoData.vue';
import LoadingComponent from '@/components/Shared/LoadingComponent.vue';
import { useRouter } from 'vue-router';

export default {
    components: {
        Carousel,
        Slide,
        Navigation,
        EventCard,
        NoData,
        LoadingComponent
    },
    setup() {
        const store = useStore();
        const eventCode = ref('');
        const enrolledEvents = ref([]);
        const user = ref({});
        const toast = useToast();
        const userDataLoading = ref(true);
        const router = useRouter();

        let perPage = ref(4);
        const chunkedItems = computed(() => {
            const chunks = [];
            for (let i = 0; i < enrolledEvents.value.length; i += perPage.value) {
                chunks.push(enrolledEvents.value.slice(i, i + perPage.value));
            }
            return chunks;
        });

        const currentIndex = ref(0);
        const carouselSettings = {
            perPage: 1,
            loop: true,
            autoplay: { delay: 3000 },
        };

        const updatePerPage = () => {
            if (window.innerWidth > 1200) {
                perPage.value = 4;
            }
            if (window.innerWidth >= 992 && window.innerWidth < 1200) {
                perPage.value = 3;
            }
            if (window.innerWidth >= 577 && window.innerWidth <= 991) {
                perPage.value = 3;
            }
            if (window.innerWidth >= 577 && window.innerWidth <= 767) {
                perPage.value = 2;
            }
            if (window.innerWidth < 576) {
                perPage.value = 1
            }
        };

        const fetchUserDetails = async () => {
            try {
                userDataLoading.value = true;
                await store.dispatch('hostprofile/fetchUserDetails');
                user.value = store.getters['hostProfile/getProfileInfoData'];
                userDataLoading.value = false;
            } catch (error) {
                console.error(error);
            }
        };

        onMounted(async () => {
            await fetchAttendeeEnrolledEvents();
            await fetchUserDetails();
            updatePerPage();
            window.addEventListener('resize', updatePerPage);
        });

        const fetchAttendeeEnrolledEvents = async () => {
            try {
                await store.dispatch('attendeeEvent/fetchAttendeeEnrolledEvents', store.getters['user/getUserId']);
                enrolledEvents.value = store.getters['attendeeEvent/getAttendeeEnrolledEvents'];
            } catch (error) {
                console.error(error);
            }
        };

        onBeforeUnmount(() => {
            window.removeEventListener('resize', updatePerPage);
        });

        const nextSlide = () => {
            currentIndex.value = (currentIndex.value + 1) % chunkedItems.value.length;
        };

        const prevSlide = () => {
            currentIndex.value = (currentIndex.value - 1 + chunkedItems.value.length) % chunkedItems.value.length;
        };

        const joinEvent = async () => {
            if (eventCode.value.length) {
                const eventData = {
                    eventCode: eventCode.value,
                    userId: store.getters['user/getUserId'],
                };
                const response = await store.dispatch('attendeeEvent/joinEvent', eventData);
                if (response.data.status) {
                    console.log(response.data)
                    toast.success(response.data.msg);
                    eventCode.value = '';
                    // eventCode.value = router;
                    router.push({name: 'attendee.event.details', params: {eventId: response.data.data.id}})
                } else {
                    toast.error(response.data.msg);
                }
            } else {
                toast.error('No code found.');
            }
        }

        return {
            chunkedItems,
            carouselSettings,
            nextSlide,
            prevSlide,
            eventCode,
            joinEvent,
            enrolledEvents,
            user,
            userDataLoading,
        };
    },
};
</script>
<style>
.carousel__prev {
    color: white;
    left: unset !important;
    right: 46px !important;
    top: -38px !important;

}

.carousel__prev:hover {
    color: white;
}

.carousel__next {
    right: -4px !important;
    top: -38px !important;
    color: white;
}

.carousel__next:hover {
    color: white !important;
}

.event-slide-icon {
    aspect-ratio: 1/1;
}

.background-div {
    background-image: url('../../../assets/util/images/banner.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

}

.info-wrapper {
    width: 100%;
}

.event-encroll-input {
    text-align: center;
    height: 44px;
    width: 90%;
    background: transparent;
    border: 1px solid #585859;
    border-radius: 8px;
}

.event-encroll-input:focus {
    background-color: transparent !important;
    border: 1px solid #585859;
    outline: none;
}

.event-encroll-input::placeholder {
    text-align: center;
    color: #FCFCFC;
}

.header-cover {
    width: 100%;
    height: 50vh;
    object-fit: cover;
}

.header-content {
    top: 20%
}

.good-morning {
    font-size: 20px !important;
    font-weight: 600;
}

.attendee-name {
    font-size: 30px !important;
    font-weight: 700;
}

@media (max-width:992px) {
    .short-info {
        align-items: center !important;
        justify-content: center !important;
    }
}
</style>
